/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SendNotificationDto = {
    /**
     * Notification title
     */
    title: string;
    /**
     * Notification body text
     */
    body: string;
    /**
     * Notification type for categorization
     */
    type: SendNotificationDto.type;
    /**
     * Delivery channels for the notification. Defaults to ["in-app"] if omitted.
     */
    channels?: Array<'push' | 'in-app' | 'email' | 'sms'>;
    /**
     * Additional data payload for the notification
     */
    data?: Record<string, any>;
    /**
     * Optional channel-specific content payload used by queue-driven notifications.
     */
    channelContent?: Record<string, any>;
};
export namespace SendNotificationDto {
    /**
     * Notification type for categorization
     */
    export enum type {
        BOOKING = 'booking',
        PAYMENT = 'payment',
        SCHEDULE = 'schedule',
        CLIENT_ACTIVITY = 'client_activity',
        MARKETING = 'marketing',
        ONBOARDING = 'onboarding',
        SUBSCRIPTION = 'subscription',
        REVIEW = 'review',
        SYSTEM = 'system',
    }
}

